var _style, _path, _path2, _circle, _line, _path3, _path4, _path5, _line2, _line3, _path6, _path7, _line4, _line5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTortoise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.3,64.6c0-19.9-16.1-36-36-36s-36,16.1-36,36c0,0,4.9,4.1,34.8,4.1S95.3,64.6,95.3,64.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.5,62.6c-2,0.2-4.3-0.1-6.6-0.9c-6-2.1-9.7-7.3-8.3-11.5s7.6-5.8,13.6-3.7c1.5,0.5,2.9,1.3,4,2.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4,
    cy: 50.1,
    r: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.4,
    y1: 60.4,
    x2: 94,
    y2: 60.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,30.6v14.5c0,1.8,1.4,3.2,3.2,3.2h13.3c1.8,0,3.2-1.4,3.2-3.2V30.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,45.1L37,51c-2.5,1.3-5.5,0.5-7.1-1.8L28,46.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.1,45.1L80.9,51c2.5,1.3,5.5,0.5,7.1-1.8l1.8-2.6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 52,
    y1: 48.3,
    x2: 52,
    y2: 59.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 65.9,
    y1: 48.6,
    x2: 65.9,
    y2: 59.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,66.4v4.9c0,0.9-0.4,1.7-1,2.3c0,0,0,0-0.1,0.1c-2,1.9-0.7,5.3,2.1,5.3h6.7c1.7,0,3.1-1.4,3.1-3.1v-7.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.1,68.4v2.9c0,0.9-0.4,1.7-1,2.3c0,0,0,0-0.1,0.1c-2,1.9-0.7,5.3,2.1,5.3h6.7c1.7,0,3.1-1.4,3.1-3.1v-8.2"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 35.6,
    y1: 51.6,
    x2: 31.5,
    y2: 60.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 84.5,
    y1: 51.5,
    x2: 86,
    y2: 59.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTortoise);
export default __webpack_public_path__ + "static/media/tortoise.82565fe2d2c75838d01fca27c63cf6bd.svg";
export { ForwardRef as ReactComponent };